import { useEffect } from "react";

const sleep=(ms:number)=>new Promise(resolve=>window.setTimeout(resolve,ms));
const clean=(value:string|null|undefined)=>(value||"").replace(/\s+/g," ").trim();

async function clickDivision(label:"steel"|"aluminum"){
  for(let attempt=0;attempt<24;attempt++){
    await sleep(75);
    const buttons=[...document.querySelectorAll<HTMLButtonElement>("button")];
    const button=buttons.find(b=>clean(b.textContent).toLowerCase().includes(label));
    if(button){button.click();await sleep(125);return true;}
  }
  return false;
}

async function findWelderRow(name:string){
  for(let attempt=0;attempt<24;attempt++){
    await sleep(100);
    const rows=[...document.querySelectorAll<HTMLTableRowElement>("table tbody tr")];
    const row=rows.find(r=>clean(r.querySelector("td:first-child b")?.textContent).toLowerCase()===name.toLowerCase());
    if(row)return row;
  }
  return null;
}

async function openWelderProfile(name:string){
  // Dashboard's own React click first navigates to Welder Qualifications.
  await sleep(175);
  let row=await findWelderRow(name);

  if(!row){
    await clickDivision("steel");
    row=await findWelderRow(name);
  }
  if(!row){
    await clickDivision("aluminum");
    row=await findWelderRow(name);
  }
  if(!row)return;

  row.scrollIntoView({behavior:"smooth",block:"center"});
  row.dataset.openWelderProfile="true";
  row.click();
  window.setTimeout(()=>delete row.dataset.openWelderProfile,0);
}

export default function DashboardQualificationNavigation(){
  useEffect(()=>{
    const onClick=(event:MouseEvent)=>{
      const target=event.target as HTMLElement;
      const action=target.closest(".dashboard .action-row") as HTMLElement|null;
      if(!action)return;
      const kind=clean(action.querySelector(".action-copy small")?.textContent).toUpperCase();
      if(kind!=="WELDER QUALIFICATION")return;
      const title=clean(action.querySelector(".action-copy b")?.textContent);
      const name=clean(title.split(" · ")[0]);
      if(name)void openWelderProfile(name);
    };
    document.addEventListener("click",onClick,true);
    return()=>document.removeEventListener("click",onClick,true);
  },[]);
  return null;
}
